import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import Message from "./Message";
import Modal from "./Modal/index.js";

// styles
import breakpoints from "core/breakpoints";
const MarketingMessageModalStyled = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        display: none;
    }
`;

// component
export const MarketingMessageModal = ({ userMessage }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <MarketingMessageModalStyled>
            <Message userMessage={userMessage} onOpenModal={() => setIsVisible(true)} />
            <Modal
                userMessage={userMessage}
                isVisible={isVisible}
                onClose={() => setIsVisible(false)}
            />
        </MarketingMessageModalStyled>
    );
};

export default MarketingMessageModal;

// prop-types
MarketingMessageModal.propTypes = {
    userMessage: PropTypes.object
};
